// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__f1nVd","notStarted":"style__notStarted__Bavbd","progress":"style__progress__GntMD","completed":"style__completed__c8mHN","optOut":"style__optOut__FhgZi"};